export default __webpack_public_path__ + "images/abdominal_blue.1c84b38dd02997c6248ba8b8bc403c64.png";